import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { CpDataApi } from './axiosInstances';
import { currentBrand, apiGatewayConsumerName, integrationApiBaseUrl, integrationApiBaseUrlLocal } from 'config';
import { useOidcAuthentication } from '@cp-shared-19/frontend-ui';

export function useAxiosWithAuthentication(): void {
    const auth = useOidcAuthentication();
    if (auth.isAuthenticated) {
        Object.assign(CpDataApi.defaults.headers, { 'x-cp-brand': currentBrand });
        if (!('process' in window)) {
            // @ts-expect-error  process is not defined
            window.process = {};
        }
        if (process?.env?.NODE_ENV === 'production') {
            Object.assign(CpDataApi.defaults.headers, {
                'x-consumer-name': apiGatewayConsumerName,
                'x-authorization-token': `Bearer ${auth.token}`,
            });
            CpDataApi.defaults.baseURL = integrationApiBaseUrl;
        } else {
            Object.assign(CpDataApi.defaults.headers, {
                'x-consumer-id': '12351',
                'x-request-idpsub': auth.idpSub,
                'x-access-token': auth.token,
            });
            CpDataApi.defaults.baseURL = integrationApiBaseUrlLocal;
        }
    }
}

export function useAxiosWithCurrentLanguage(): void {
    const { i18n } = useTranslation(undefined, { useSuspense: false });
    const { language } = i18n;
    useEffect(() => {
        if (language) {
            Object.assign(CpDataApi.defaults.headers, {
                'Accept-Language': language,
            });
        }
    }, [language]);
}
